<script setup lang="ts">
import { computed } from 'vue';

import QuantityStepper from '@/components/base/form/QuantityStepper.vue';
import ThemedButton from '@/components/base/ThemedButton.vue';
import ProductCardWithOptions from '@/components/product-card/ProductCardWithOptions.vue';
import { gtag } from '@/utils/analytics';
import { ProductCardData } from '@/utils/productCard';

const props = defineProps<{ addOn: ProductCardData; position: number; quantity: number }>();

const emit = defineEmits<{
  'select-add-on': [addOn: ProductCardData, quantity: number];
}>();

const quantity = computed({
  get: () => props.quantity,
  set: (val) => {
    emit('select-add-on', props.addOn, val);
  },
});

const handleSelectAddOn = () => {
  emit('select-add-on', props.addOn, 1);
  gtag('event', 'select_add_on', {
    add_on_sku: props.addOn.sku,
  });
};
</script>

<template>
  <ProductCardWithOptions
    layout="plp"
    :position="position"
    :product="addOn"
    :linkToPdp="false"
    trackingEventLocation="pdpAddOn"
  >
    <template #button>
      <ThemedButton
        v-if="quantity === 0"
        class="my-2"
        theme="white"
        size="small"
        @click="handleSelectAddOn"
      >
        Select
      </ThemedButton>
      <QuantityStepper
        v-else
        v-model="quantity"
        :min="0"
        ariaLabel="add on quantity"
        class="justify-between my-2"
      >
        {{ quantity }} Selected
      </QuantityStepper>
    </template>
  </ProductCardWithOptions>
</template>
